<template>
	<!-- Edit Form -->
	<div v-if="selectedCategory">
		<h3 >Edit Category <small>(under construction)</small></h3>
		<form class="border mb-2">
			<div class="form-group p-3 border-bottom m-0">
				<label>Category</label>
				<input type="text" class="form-control" v-model="selectedCategory.name">
			</div>
			<div class="form-group p-3 border-bottom m-0">
				<div class="border-bottom mb-3" v-for="(subCategory, j) in selectedCategory.subs" :key="j">
				<label class="m-0">Sub-Category</label>
					<input type="text" class="form-control" v-model="subCategory.name">
					<button class="btn btn-danger my-1" type="button" v-on:click="deleteSubcategory(subCategory.name)">Delete</button>
					<div class="row">
						<div class="col-md-6 pt-2" v-for="(topic, i) in subCategory.topics" :key="i">
							<input type="text" class="form-control" placeholder="Topic" v-model="subCategory.topics[i]">
							<button class="btn btn-danger my-1" type="button" v-on:click="deleteTopic(subCategory.topics[i])">Delete</button>
						</div>
					</div>
					<div class="text-center">
						<button class="btn bg-white text-primary font-weight-bold m-0 mt-3" type="button" v-on:click="addTopic(subCategory.topics)">+ add topic</button>
						
					</div>
				</div>
				<button class="btn btn-primary font-weight-bold m-0" type="button" v-on:click="addSubCategory(selectedCategory)">+ add sub-category</button>
			</div>

			<button type="button" class="btn btn-primary font-weight-bold my-3 mx-3" v-on:click="save()">edit</button>
			<!-- <button type="button" class="btn btn-danger font-weight-bold" v-on:click="resetForm">reset</button> -->
			<button type="button" class="btn btn-warning font-weight-bold" v-on:click="cancel">cancel</button>
		</form>
	</div>  
</template>

<script>
	import App from '@/App'
	export default {
		data: () => {
			return {
				url: App.data().url,
				selectedCategory: null
			}
		},
		mounted(){
			this.$root.$on('category-selected', (cat) => {
				this.selectedCategory = cat;
			})
		},
		methods: {
			resetForm(){

			},
			save(){
				App.methods.postData(this.url.category, this.selectedCategory, () => {
				});
			},
			addSubCategory(category) {
				category.subs.push({
					name:"New Sub-Category",
					topics: ["New Topic"]
				});
			},
			addTopic(container) {
				container.push("New Topic")
			},
			cancel(){
				this.selectedCategory = null;
				this.$root.$emit('category-unselected');
			},
			deleteSubcategory(subs){
				console.log("INI YANG DIHAPUS", subs)
				alert("FUNGSI BELUM DIBIKIN")
			},
			deleteTopic(topic){
				console.log("INI YANG DIHAPUS",topic)
				alert("FUNGSI BELUM DIBIKIN")
			}
		}
	}
</script>